angular.module('dnecom')
    .directive('panel', ['$cookies', 'StorageBag', function ($cookies, StorageBag) {

        var self = this;

        self.BAG_KEY = 'es-ui-panels';
        self.defaults = {
            panelType: 'bordered', // default, bordered, transparent
            panelCollapsible: 'true',
            panelExpandable: 'false',
            panelCondensed: 'false',
            panelTitleSeparator: 'false',
            panelHover: 'false'
        };

        self.getStorage = function () {
            return StorageBag.get(self.BAG_KEY)
        };

        self.setStorage = function (data) {
            StorageBag.put(self.BAG_KEY, data)
        };

        self.initLocalStorage = function (attrs, panelId) {
            if (_.isUndefined(self.getStorage()) || _.isNull(self.getStorage())) {
                self.setStorage({});
            }

            var storage = self.getStorage();

            if (_.isUndefined(storage[panelId])) {
                storage[panelId] = {};
                self.setStorage(storage);
            }
        };

        return {
            type: 'EA',
            transclude: true,
            replace: true,
            template: '<div class="panel panel-{{ panelType }}" ng-class="{ \'panel-collapsed\': panel.collapsed, \'panel-maximized\': panel.maximized,\'panel-condensed\': panelCondensed == \'true\', \'panel-hover\': panelHover == \'true\' }">\n    <div class="panel-heading" ng-click="collapse()" ng-class="{ \'separator\': panelTitleSeparator == \'true\' }">\n        <div class="panel-title">{{ panelTitle }}</div>\n        <div class="panel-controls" ng-if="attrs.onRefresh || panelExpandable == \'true\' || panelCollapsible == \'true\' || attrs.onClose">\n            <ul>\n                <li ng-show="attrs.onRefresh">\n                    <a href="" class="portlet-refresh" ng-click="onRefresh()">\n                        <i class="portlet-icon portlet-icon-refresh"></i>\n                    </a>\n                </li>\n                <li ng-show="panelExpandable == \'true\'">\n                    <a href="" class="portlet-maximize" ng-click="toggleMaximize()">\n                        <i class="portlet-icon portlet-icon-maximize"></i>\n                    </a>\n                </li>\n                <li ng-show="panelCollapsible == \'true\'">\n                    <a href="" class="portlet-collapse">\n                        <i ng-show="!panel.collapsed" class="pg-arrow_maximize"></i>\n                        <i ng-show="panel.collapsed" class="pg-arrow_minimize"></i>\n                    </a>\n                </li>\n                <li ng-show="attrs.onClose">\n                    <a href="" class="portlet-close" ng-click="onClose()">\n                        <i class="portlet-icon portlet-icon-close"></i>\n                    </a>\n                </li>\n            </ul>\n        </div>\n  <div class="panel-title-helper">{{ panelTitleHelper }}</div>\n  </div>\n\n    <div ng-show="!panel.collapsed" class="panel-body {{ panelBodyClass }}" ng-transclude></div>\n\n    <div ng-show="panelLoading" class="portlet-progress">\n        <div class="progress-circle-indeterminate progress-circle-primary"></div>\n    </div>\n</div>',
            scope: {
                panelId: '@',
                panelType: '@',
                panelTitle: '@',
                panelTitleHelper: '@',
                panelTitleSeparator: '@',
                panelCollapsible: '@',
                panelExpandable: '@',
                panelCondensed: '@',
                panelHover: '@',
                panelBodyClass: '@',
                panelLoading: '=?',
                onMinimize: '&',
                onMaximize: '&',
                onCollapse: '&',
                onExpand: '&',
                onClose: '&',
                onRefresh: '&'
            },
            link: function (scope, element, attrs) {
                // Init
                if (_.isUndefined(scope.panelId)) {
                    scope.panelId = attrs.id
                }

                self.initLocalStorage(attrs, scope.panelId);

                scope.panel = {
                    collapsed: self.getStorage()[scope.panelId] ? self.getStorage()[scope.panelId].collapsed : false,
                    maximized: false
                };

                scope.attrs = attrs;

                angular.forEach(self.defaults, function (value, key) {
                    if (_.isUndefined(scope[key])) {
                        scope[key] = value
                    }
                });
                // Scope functions
                scope.collapse = function () {
                    scope.panel.collapsed = !scope.panel.collapsed;

                    var storage = self.getStorage();
                    storage[scope.panelId].collapsed = scope.panel.collapsed;
                    self.setStorage(storage);

                    if (scope.panel.collapsed) {
                        scope.onCollapse();
                    } else {
                        scope.onExpand();
                    }
                };

                if (scope.panelId) {
                    scope.$on('toogle:panel-collapse', function (evt, data) {
                        if (data.panelId == scope.panelId) {
                            scope.panel.collapsed = false;

                            var storage = self.getStorage();
                            storage[scope.panelId].collapsed = scope.panel.collapsed;
                            self.setStorage(storage);
                        }
                    });
                }

                scope.toggleMaximize = function () {
                    scope.panel.maximized = !scope.panel.maximized;

                    if (scope.panel.maximized) {
                        scope.onMaximize();
                    } else {
                        scope.onMinimize();
                    }
                }
            }
        }
    }]);
